import { render, staticRenderFns } from "./Organize.vue?vue&type=template&id=35aabe97&scoped=true"
import script from "./Organize.vue?vue&type=script&lang=js"
export * from "./Organize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aabe97",
  null
  
)

export default component.exports